import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CustomCursor } from './components/CustomCursor';
import { Home } from './pages/Home';
import { Projects } from './pages/Projects';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-bg-warm font-sans font-light selection:bg-accent/30 selection:text-primary" data-id="element-2">
        <CustomCursor data-id="element-3" />
        <Navbar data-id="element-4" />
        <Routes data-id="element-5">
          <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/projects" element={<Projects data-id="element-9" />} data-id="element-8" />
          <Route path="/projects/:category" element={<Projects data-id="element-11" />} data-id="element-10" />
        </Routes>
        <Footer data-id="element-12" />
      </div>
    </BrowserRouter>;
}